// Module
var code = `<form name="\$ctrl.formLai" novalidate>
    <!-- Loan account information -->
    <div id="loan-account-information">
      <h2 class="section-header section-header--upper-margin">Loan Account Information</h2>
      <table class="table">
        <tbody class="tbody">

        <tr>
          <td class="label">Loan Class:</td>
          <td class="values">
            <select
                    ng-model="\$ctrl.loanInformation.loanClassId"
                    ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_CLASS"
                    ng-required="true"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"></select>
          </td>
        </tr>
        <tr>
          <td class="label">Loan Purpose:</td>
          <td class="values">
            <select
                    ng-model="\$ctrl.loanInformation.loanPurposeId"
                    ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_PURPOSE"
                    ng-required="true"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"></select>
          </td>
        </tr>
        <tr>
          <td class="label">Loan Security:</td>
          <td class="values">
            <select
                    ng-model="\$ctrl.loanInformation.loanSecurityId"
                    ng-options="title.id as title.description for title in \$ctrl.visibleLoanSecurityOptions"
                    ng-change="\$ctrl.setLoanSecurityType()"
                    required
                    ng-disabled="!\$ctrl.isEditModeEnabled()">
            </select>
          </td>
        </tr>
        <tr>
          <td class="label">Loan Economic Activity:</td>
          <td class="values">
            <select
                    ng-model="\$ctrl.loanInformation.loanEconomicActivityId"
                    ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_ECONOMIC_ACTIVITY"
                    ng-required="true"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"></select>
          </td>
        </tr>
        <tr>
          <td class="label">Microfinance Classification:</td>
          <td class="values">
            <select
                    ng-model="\$ctrl.loanInformation.loanMicrofinanceClassificationId"
                    ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_MICROFINANCE_CLASSIFICATION"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"></select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.loanProduct.microfinance">
          <td class="label">Microfinance Client Type:</td>
          <td class="values">
            <select
                    ng-model="\$ctrl.loanInformation.loanMicrofinanceClientTypeId"
                    ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_MICROFINANCE_CLIENT_TYPE"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"></select>
          </td>
        </tr>
        <tr>
          <td class="label">Borrower Type:</td>
          <td class="values">
            <select
                    ng-model="\$ctrl.loanInformation.loanBorrowerTypeId"
                    ng-options="item.id as item.description for item in \$ctrl.dict.LOAN_BORROWER_TYPE"
                    ng-required="true"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"></select>
          </td>
        </tr>
        <tr>
          <td class="label">Transaction Type:</td>
          <td class="values">
            <select
              ng-model="\$ctrl.loanInformation.loanTransactionTypeId"
              ng-options="item.id as item.description for item in \$ctrl.dict.LOAN_TRANSACTION_TYPE"
              ng-required="true"
              ng-disabled="!\$ctrl.isEditModeEnabled()"></select>
          </td>
        </tr>
        <tr>
          <td class="label">CIC Contract Type:</td>
          <td class="values">
            <select
                    ng-model="\$ctrl.loanInformation.cicContractType"
                    ng-options="item.value as item.label for item in \$ctrl.cicContractTypes"
                    ng-required="true"
                    ng-disabled="!\$ctrl.isEditModeEnabled()"></select>
          </td>
        </tr>
        <tr>
          <td class="label">With Board Resolution:</td>
          <td class="values">
            <select
              ng-model="\$ctrl.loanInformation.withBoardResolution"
              ng-disabled="!\$ctrl.isEditModeEnabled()"
              boolean-options=""></select>
          </td>
        </tr>
        <tr>
          <td class="label">Interest Setting:</td>
          <td class="values">
            <select
              ng-model="\$ctrl.loanInformation.interestSetting"
              ng-disabled="!\$ctrl.isEditModeEnabled()"
              ng-change="\$ctrl.updateRepricingFrequency()"
              ng-options="item.value as item.label for item in \$ctrl.interestSetting"></select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.loanInformation.interestSetting == 'REPRICEABLE'">
          <td class="label">Repricing Frequency:</td>
          <td class="values">
            <select
              ng-model="\$ctrl.loanInformation.repricingFrequency"
              ng-required="\$ctrl.loanInformation.interestSetting == 'REPRICEABLE'"
              ng-disabled="!\$ctrl.isEditModeEnabled()"
              ng-options="item.value as item.label for item in \$ctrl.repricingFrequency"></select>
          </td>
        </tr>
        <tr>
          <td class="label">Restructure Credit Code:</td>
          <td class="values">
            <select
              ng-model="\$ctrl.loanInformation.restructureCreditType"
              ng-disabled="!\$ctrl.isEditModeEnabled()"
              ng-options="item.value as item.label for item in \$ctrl.restructureCreditType"></select>
          </td>
        </tr>
        <tr>
          <td class="label mis-group">Loan Purpose to Industry:</td>
          <td class="values mis-group">
            <loan-industry-purpose
                industry-purpose-id="\$ctrl.loanInformation.loanIndustryPurposeId"
                ng-required="true"
                ng-disabled="!\$ctrl.isEditModeEnabled()"
            >
            </loan-industry-purpose>
          </td>
        </tr>
        <tr>
          <td class="label mis-group">MIS Group:</td>
          <td class="values mis-group">
              <loan-mis-group
                mis-group-id="\$ctrl.loanInformation.misGroupId"
                ng-disabled="!\$ctrl.isEditModeEnabled() || \$ctrl.loanStatus === 'PENDING'"
                assigned-category-ids="\$ctrl.categoryIds"
                customer-id="\$ctrl.customerId"
                ng-required="true">
              </loan-mis-group>
              <span ng-if="\$ctrl.loanStatus === 'PENDING'">
                Loan mis group cannot be edited for not released loan
              </span>
          </td>
        </tr>
        </tbody>
      </table>
      <custom-field-input
        group="'LOAN'"
        available-custom-fields="\$ctrl.loanProduct.productDefinition.customFieldDefinitionIds"
        custom-field-values="\$ctrl.customFieldValues"
        assigned-category-ids="\$ctrl.categoryIds"
        branch-id="\$ctrl.branchId"
        edit-mode="\$ctrl.isEditModeEnabled()"
        customer-id="\$ctrl.customerId">
      </custom-field-input>
    </div>
    <loan-collateral ng-if="\$ctrl.loanProduct.collateralRequirement !== 'DISALLOWED' && \$ctrl.customerId > 0 && !\$ctrl.cleanLoanSecuritySelected()"
                     loan-security-id="\$ctrl.loanInformation.loanSecurityId"
                     loan-security-type="\$ctrl.getLoanSecurityType()"
                     loan-collaterals="\$ctrl.loanCollaterals"
                     edit-mode="\$ctrl.isEditModeEnabled()"
                     customer-id="\$ctrl.customerId">

    </loan-collateral>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/page/details/lai/customer-loan-create-lai-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;